import { useCallback, useState } from "react";
import { generateQuestion } from "./quizUtils";
import QuizQuestion from "./QuizQuestion";
import styles from "./Quiz.module.css";

const MODES = [
  { key: "mixed", label: "Всё" },
  { key: "name", label: "Название" },
  { key: "picture", label: "Картинка" },
  { key: "roots", label: "Корни" },
];

export default function QuizPractice({ poses, language = "russian", progress = {}, onAnswer, rootItems = [] }) {
  const [typeFilter, setTypeFilter] = useState("mixed");
  const [question, setQuestion] = useState(() =>
    poses.length ? generateQuestion(poses, "mixed", language, progress, rootItems) : null
  );
  const [qIndex, setQIndex] = useState(0);
  const [score, setScore] = useState({ correct: 0, total: 0 });
  const [answered, setAnswered] = useState(false);

  const nextQuestion = useCallback(
    (filter) => {
      setQuestion(generateQuestion(poses, filter ?? typeFilter, language, progress, rootItems));
      setAnswered(false);
      setQIndex((i) => i + 1);
    },
    [poses, typeFilter, language, progress, rootItems]
  );

  const handleModeChange = (key) => {
    setTypeFilter(key);
    setScore({ correct: 0, total: 0 });
    nextQuestion(key);
  };

  const handleAnswered = (isCorrect) => {
    setAnswered(true);
    setScore((s) => ({ correct: s.correct + (isCorrect ? 1 : 0), total: s.total + 1 }));
    onAnswer?.(question.pose, isCorrect);
  };

  if (poses.length < 2) {
    return <p className={styles.emptyNote}>Недостаточно поз для квиза.</p>;
  }

  const rootsAvailable = rootItems.length >= 4;

  return (
    <div className={styles.quizWrap}>
      <div className={styles.modeRow}>
        {MODES.map((m) => (
          <button
            key={m.key}
            type="button"
            className={typeFilter === m.key ? styles.modeBtnActive : styles.modeBtn}
            onClick={() => handleModeChange(m.key)}
            disabled={m.key === "roots" && !rootsAvailable}
          >
            {m.label}
          </button>
        ))}
      </div>

      <div className={styles.scoreRow}>
        Счёт: {score.correct} / {score.total}
      </div>

      {question && (
        <QuizQuestion
          key={qIndex}
          question={question}
          onAnswered={handleAnswered}
          rootItems={rootItems}
          language={language}
        />
      )}

      <button type="button" className={styles.nextBtn} onClick={() => nextQuestion()} disabled={!answered}>
        Следующий вопрос
      </button>
    </div>
  );
}
